<template>
	<div>

		<div class="row" v-if="loading">
			<div class="columns text-center">
				<!-- <h5>Loading</h5> -->
				<img
					src="/assets-prod/images/animaticons/cfk-spinner-v2-slower.gif"
					alt="ClassForKids Loading Spinner"
				/>
			</div>
		</div>

		<div
			class="panel pbs pts mbn"
			style="background-color: var(--skin-primary, #2196f3); border: none; border-radius: 0;"
			v-if="!loading"
		>
			<div class="row">
				<div class="columns pln prn">
					<h5 class="mbn" style="color: #fff !important">
						<i class="fa fa-search" aria-hidden="true"></i>
						{{ filteredText }}
					</h5>
				</div>
			</div>
		</div>

		<div
			class="panel ptm pbs"
			style="background-color: #F8F8F8; border: 1px solid #dddddd; border-radius: 0"
			v-if="!loading"
		>
			<div class="row pan man">
				<div class="columns text-right prn pbs">
					<strong v-if="filtering">
						<a v-on:click.prevent="resetFilters">Reset Filters</a>
					</strong>
					<span v-else>&nbsp;</span>
				</div>
			</div>

			<div class="row collapse">
				<!-- <label>What kind of classes do you need?</label> -->

				<div class="small-12 medium-3 columns">
					<span class="prefix">Show me</span>
				</div>

				<div class="small-4 medium-3 columns">
					<select class="mbn" v-model="selectedAge">
						<option value="any">for any age</option>
						<option :value="age.value" v-for="age in ages">{{
							age.text
						}}</option>
					</select>
				</div>

				<div class="small-4 medium-3 columns">
					<select v-model="day" class="mbn">
						<option value="any">any day</option>
						<option
							:disabled="!dayIsAvailable(day.longForm)"
							v-for="day in daysOfTheWeek"
							:value="day.shortForm"
							>{{ day.longForm }}</option
						>
					</select>
				</div>

				<div class="small-4 medium-3 columns">
					<select v-model="availableTime" class="mbn">
						<option value="any">any time</option>
						<option
							:disabled="!timeIsAvailable(time)"
							:value="time"
							v-for="time in times"
							>{{ time }}</option
						>
					</select>
				</div>

				<!-- 	    <div class="small-4 medium-3 columns">
					<select class="mbn">
						<option value="any">for any age</option>
						<option :value="age" v-for="age in availableAges">{{age}}</option>
					</select>
			    </div> -->
			</div>

			<div class="row">
				<div class="columns small-12 medium-4 large-4 large-offset-3">
					<input
						id="available"
						value="available"
						type="checkbox"
						v-model="available"
					/>
					<label class="right inline" for="available"
						>Spaces Available</label
					>
				</div>

				<div
					class="columns small-12 medium-3 large-2"
					v-if="showCampsAndTermsControls"
				>
					<input
						id="camps"
						value="camps"
						type="checkbox"
						v-model="showCamps"
					/>
					<label class="right inline" for="camps">Camps</label>
				</div>

				<div
					class="columns small-6 medium-3 large-2"
					v-if="showCampsAndTermsControls"
				>
					<input
						id="terms"
						value="terms"
						type="checkbox"
						v-model="showTerms"
					/>
					<label class="right inline" for="terms">Classes</label>
				</div>

				<div class="columns small-6 medium-2 large-1">
					<a
						v-on:click.prevent="showFilters = !showFilters"
						class="right inline text-info mtm"
						>{{ showFilters ? 'Hide' : 'More' }}...</a
					>
				</div>
			</div>

			<div class="row collapse" v-if="showFilters">
				<div class="columns small-12 medium-6">
					<label for="class">Want a specific class?</label>
					<select v-model="className">
						<option value="any">Any Class</option>
						<option
							v-for="className in classes"
							:value="className"
							>{{ className }}</option
						>
					</select>
				</div>

				<div class="columns small-12 medium-6">
					<label for="class">Want a specific venue?</label>
					<select v-model="venueName">
						<option value="any">Any Venue</option>
						<option
							v-for="venueName in venues"
							:value="venueName"
							>{{ venueName }}</option
						>
					</select>
				</div>
			</div>
		</div>

		<div class="row pas" v-if="!loading">
			<div class="columns">
			   	 <Term v-for="term in terms" :term="term" :key="'term:' + term.termId" />
					 <Camp v-for="camp in camps" :camp="camp" :key="'camp:' + camp.campId" />
			</div>
		</div>
	</div>
</template>

<script>
import { format } from 'date-fns';
import Term from './Term';
import Camp from './Camp';

function initialFilterState() {
  return {
    day: 'any',
    days: [],
    availableDays: [],
    availableTime: 'any',
    availableTimes: [],
    availableAges: [],
    selectedAge: 'any',
    className: 'any',
    venueName: 'any',
    showCamps: 'true',
    showTerms: 'true',
    onlyAvailableRuns: false,
    age: {
      value: '',
      unit: 'years',
    },
    time: {
      morning: 'false',
      afternoon: 'false',
      evening: 'false',
    },
    distance: {
      postcode: '',
      latitude: '',
      longitude: '',
      radius: 5,
    },
  };
}
export default {
  name: 'App',
  data() {
    return {
      // loading: true,
      showFilters: true,
      daysOfTheWeek: [
        {
          longForm: 'Monday',
          shortForm: 'mon',
        },
        {
          longForm: 'Tuesday',
          shortForm: 'tue',
        },
        {
          longForm: 'Wednesday',
          shortForm: 'wed',
        },
        {
          longForm: 'Thursday',
          shortForm: 'thu',
        },
        {
          longForm: 'Friday',
          shortForm: 'fri',
        },
        {
          longForm: 'Saturday',
          shortForm: 'sat',
        },
        {
          longForm: 'Sunday',
          shortForm: 'sun',
        },
      ],

      times: ['Morning', 'Afternoon', 'Evening'],

      ages: [
        {
          value: 0.5,
          text: 'Under 12 months',
        },
        {
          value: 1,
          text: '12 - 24 months',
        },
        {
          value: 2,
          text: '2 Years',
        },
        {
          value: 3,
          text: '3 Years',
        },
        {
          value: 4,
          text: '4 Years',
        },
        {
          value: 5,
          text: '5 Years',
        },
        {
          value: 6,
          text: '6 Years',
        },
        {
          value: 7,
          text: '7 Years',
        },
        {
          value: 8,
          text: '8 Years',
        },
        {
          value: 9,
          text: '9 Years',
        },
        {
          value: 10,
          text: '10 Years',
        },
        {
          value: 11,
          text: '11 Years and over',
        },
      ],
    };
  },

  methods: {
    getPublicSchedule() {
      return this.$store.dispatch('GET_SCHEDULE_DATA');
    },

    dayFilter(camp) {
      return true;

      const campDay = format(
        camp.campStartTime * 1000,
        'ddd',
      ).toLowerCase();

      // var campDay = moment
      // 	.utc(camp.campStartTime * 1000)
      // 	.format('ddd')
      // 	.toLowerCase();
      const filterDay = this.$store.getters.day;

      if (filterDay == 'any' || campDay == filterDay) {
        return true;
      }
    },
    classFilter(camp) {
      const campClass = camp.className.toLowerCase();
      const filterClass = this.$store.getters.className.toLowerCase();

      if (filterClass == 'any' || campClass == filterClass) {
        return true;
      }
    },

    venueFilter(camp) {
      const campVenue = camp.venueName.toLowerCase();
      const filterVenue = this.$store.getters.venueName.toLowerCase();

      if (filterVenue == 'any' || campVenue == filterVenue) {
        return true;
      }
    },

    onlyForASpecificAgeCampSelectFilter(camp) {
      const filterValue = this.$store.getters.selectedAge;
      const ageFrom = camp.ageFromInMonths;
      const ageTo = camp.ageToInMonths;

      if (filterValue == 'any' || (ageFrom == 0 && ageTo == 0)) {
        return camp;
      } if (filterValue < 1) {
        return ageTo > 0 && ageFrom < 12;
      } if (filterValue == 11) {
        return ageTo >= 132;
      }
      return (
        Math.floor(ageTo / 12) >= filterValue
					&& Math.floor(ageFrom / 12) <= filterValue
      );
    },

    resetFilters() {
      this.$store.commit('RESET_FILTERS');
    },

    getPostCodeDetails() {
      this.$store
        .dispatch('GET_LAT_LONG_FROM_POSTCODE', this.postcode)
        .then((response) => {

        });
    },

    dayIsAvailable(day) {
      const { availableDays } = this.$store.getters;
      if (availableDays.indexOf(day) != -1) {
        return true;
      }
      return false;
    },

    timeIsAvailable(time) {
      const { availableTimes } = this.$store.getters;
      if (availableTimes.indexOf(time) != -1) {
        return true;
      }
      return false;
    },
  },

  computed: {
    shouldShowFilters() {
      let countOfItems = 0;
      countOfItems += this.$store.getters.camps.length;
      Object.values(this.$store.getters.terms).forEach((term) => {
        const runs = Object.values(term.runs);
        countOfItems += runs.length;
      });

      return countOfItems > 8;
    },

    terms() {
      if (this.showTerms) {
        return Object.values(this.$store.getters.terms)
            .sort((a, b) => {
              return (a.termStartDateTime > b.termStartDateTime) - (a.termStartDateTime < b.termStartDateTime);
            });
      }
      return [];
    },
    camps() {
      if (this.showCamps) {
        return this.$store.getters.camps
          .filter(this.dayFilter)
          .filter(this.classFilter)
          .filter(this.venueFilter)
          .filter(this.onlyForASpecificAgeCampSelectFilter);
      }
      return [];
    },

    showTerms: {
      get() {
        return this.$store.getters.showTerms;
      },

      set(value) {
        this.$router.push({
          query: { ...this.$route.query, showTerms: value },
        });
        this.$store.commit('UPDATE_SHOW_TERMS_FILTER', value);
      },
    },

    showCamps: {
      get() {
        return this.$store.getters.showCamps;
      },

      set(value) {
        this.$router.push({
          query: { ...this.$route.query, showCamps: value },
        });
        this.$store.commit('UPDATE_SHOW_CAMPS_FILTER', value);
      },
    },

    showCampsAndTermsControls() {
      return (
        this.$store.getters.camps.length > 0
				&& this.$store.getters.terms.length > 0
      );
    },

    classes() {
      return this.$store.getters.classes;
    },

    venues() {
      return this.$store.getters.venues;
    },

    day: {
      get() {
        return this.$store.getters.day;
      },

      set(value) {
        this.$router.push({
          query: { ...this.$route.query, day: value },
        });
        this.$store.commit('UPDATE_DAY_FILTER', value);
      },
    },

    days: {
      get() {
        return this.$store.getters.days;
      },

      set(value) {
        this.$router.push({
          query: { ...this.$route.query, days: value },
        });
        this.$store.commit('UPDATE_DAYS_FILTER', value);
      },
    },

    className: {
      get() {
        return this.$store.getters.className;
      },

      set(value) {
        if (value) {
          this.$router.push({
            query: { ...this.$route.query, className: value },
          });
          this.$store.commit('UPDATE_CLASS_FILTER', value);
        }
      },
    },

    venueName: {
      get() {
        return this.$store.getters.venueName;
      },

      set(value) {
        if (value) {
          this.$router.push({
            query: { ...this.$route.query, venueName: value },
          });
          this.$store.commit('UPDATE_VENUE_FILTER', value);
        }
      },
    },

    available: {
      get() {
        return this.$store.getters.onlyAvailableRuns;
      },

      set(value) {
        this.$router.push({
          query: { ...this.$route.query, onlyAvailableRuns: value },
        });
        this.$store.commit('UPDATE_AVAILABLE_RUNS_FILTER', value);
      },
    },

    availableTimes() {
      return this.$store.getters.availableTimes;
    },

    ageValue: {
      get() {
        return this.$store.getters.ageFilterValue;
      },

      set(value) {
        this.$router.push({
          query: { ...this.$route.query.age, value },
        });
        this.$store.commit('UPDATE_AGE_FILTER_VALUE', value);
      },
    },

    ageUnit: {
      get() {
        return this.$store.getters.ageFilterUnit;
      },

      set(value) {
        this.$router.push({
          query: { ...this.$route.query.age, unit: value },
        });
        this.$store.commit('UPDATE_AGE_FILTER_UNIT', value);
      },
    },

    timeFilterMorning: {
      get() {
        return this.$store.getters.timeFilterMorning;
      },

      set(value) {
        this.$router.push({
          query: { ...this.$route.query.time, morning: value },
        });

        const payload = {
          time: 'morning',
          value,
        };

        this.$store.commit('UPDATE_TIME_FILTER', payload);
      },
    },

    timeFilterAfternoon: {
      get() {
        return this.$store.getters.timeFilterAfternoon;
      },

      set(value) {
        this.$router.push({
          query: { ...this.$route.query.time, afternoon: value },
        });

        const payload = {
          time: 'afternoon',
          value,
        };

        this.$store.commit('UPDATE_TIME_FILTER', payload);
      },
    },

    timeFilterEvening: {
      get() {
        return this.$store.getters.timeFilterEvening;
      },

      set(value) {
        this.$router.push({
          query: { ...this.$route.query.time, evening: value },
        });

        const payload = {
          time: 'evening',
          value,
        };

        this.$store.commit('UPDATE_TIME_FILTER', payload);
      },
    },

    availableTime: {
      get() {
        return this.$store.getters.availableTime;
      },

      set(value) {
        this.$router.push({
          query: { ...this.$route.query, availableTime: value },
        });

        this.$store.commit('UPDATE_AVAILABLE_TIME_FILTER', value);
      },
    },

    postcode: {
      get() {
        return this.$store.getters.postcode;
      },

      set(value) {
        this.$store.commit('UPDATE_POSTCODE', value);
      },
    },

    selectedAge: {
      get() {
        return this.$store.getters.selectedAge;
      },

      set(value) {
        this.$store.commit('UPDATE_SELECTED_AGE', value);
      },
    },

    loading() {
      return this.$store.getters.loading;
    },

    // BREAK THIS DOWN
    filteredText() {
      let textString = 'Filtered by ';

      // Availability
      if (this.available) {
        textString += 'available to book';
      } else {
        textString += 'all classes';
      }

      // Age
      if (this.selectedAge) {
        if (this.selectedAge == 'any') {
          textString += ', for any age';
        } else if (this.selectedAge == 0.5) {
          textString += ', for children up to 6 months';
        } else if (this.selectedAge == 11) {
          textString += `, for children 11 and over ${this.selectedAge}`;
        } else {
          textString += `, for children up to ${this.selectedAge}`;
        }
      }
      // Days
      // terrible stuff here lad...
      if (this.day == 'any') {
        textString += ', on any day';
      } else if (this.day == 'mon') {
        textString += ', on Monday';
      } else if (this.day == 'tue') {
        textString += ', on Tuesday';
      } else if (this.day == 'wed') {
        textString += ', on Wednesday';
      } else if (this.day == 'thu') {
        textString += ', on Thursday';
      } else if (this.day == 'fri') {
        textString += ', on Friday';
      } else if (this.day == 'sat') {
        textString += ', on Saturday';
      } else if (this.day == 'sun') {
        textString += ', on Sunday';
      }

      // Time
      if (this.availableTime == 'any') {
        textString += ', any time';
      } else {
        textString += `, in the ${this.availableTime}`;
      }

      return textString;
    },

    filtering() {
      const originalFilterState = initialFilterState();
      return (
        JSON.stringify(this.$store.state.filters)
				!= JSON.stringify(originalFilterState)
      );
    },
  },
  created() {
    this.getPublicSchedule();
  },
  mounted() {
    const queryStringKeyNames = Object.keys(this.$route.query);
    for (const i in queryStringKeyNames) {
      const propertyName = queryStringKeyNames[i];
      const propertyValue = this.$route.query[queryStringKeyNames[i]];

      this[propertyName] = propertyValue;
      // this.$route.query[queryStringKeyNames[i]] = this.$route.query[queryStringKeyNames[i]]
    }
  },

  components: {
    Term,
    Camp,
  },
};
</script>

<style scoped>
img {
	max-width: 15%;
}
</style>
